export default "__VITE_ASSET__z0lC_tcW__"